import { RadioGroup } from "@headlessui/react";
import CheckIcon from "../../Icons/CheckIcon";
import { ChaptersDTO } from "../../../api/Chapters/GetAllChapters";
import Chevron from "../../Icons/Chevron";
import Button from "../../Shared/Button";

interface ChooseLectureProps {
  data: ChaptersDTO[] | undefined;
  selected: ChaptersDTO | null;
  setSelected: React.Dispatch<React.SetStateAction<ChaptersDTO | null>>;
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  message:string;
}

const ChooseOpenLecture = ({
  data,
  selected,
  setSelected,
  currentStep,
  setCurrentStep,
  message
}: ChooseLectureProps) => {
  let lectureNumber = 1;

  return (
    <>
      <div className="max-w-[950px] mx-auto w-full flex items-center flex-col pb-10 border-b border-black/15">
        <div className="w-full max-w-[544px]">
          <h1 className="text-2xl font-bold mb-2.5">Select a lesson</h1>
          <p className="text-lightGray font-medium">
            {message}
          </p>
          <div className="mx-auto w-full">
            <RadioGroup
              value={selected}
              onChange={setSelected}
            >
              <div className="space-y-2 max-h-[600px] overflow-y-scroll">
                {data?.map((chapter: ChaptersDTO) => (
                  <div key={chapter.id}>
                    {chapter.lectures.map((lecture) => {
                      const currentLectureNumber = lectureNumber++;
                      return (
                        <RadioGroup.Option
                          key={lecture.id}
                          value={{
                            OpenLectureId: lecture.id,
                            chapterId: chapter.id,
                          }}
                          className={({ active }) =>
                            `${active ? "bg-[#4379EE] text-white ring-white ring-opacity-60 " : "bg-white"}
                             relative flex cursor-pointer px-5 py-4 border-b border-black/20 focus:outline-none transition ease-in-out duration-300`
                          }
                        >
                          {({ checked }) => (
                            <div className="flex w-full items-center justify-between">
                              <div className="flex items-center">
                                <div className="text-sm">
                                  <RadioGroup.Label
                                    as="p"
                                    className={`font-bold text-lg ${checked ? "text-white" : ""}`}
                                  >
                                    {currentLectureNumber} - {lecture.title}
                                  </RadioGroup.Label>
                                </div>
                              </div>
                              {checked ? (
                                <CheckIcon />
                              ) : (
                                <Chevron className="text-inherit" />
                              )}
                            </div>
                          )}
                        </RadioGroup.Option>
                      );
                    })}
                  </div>
                ))}
              </div>
            </RadioGroup>
          </div>
        </div>
      </div>
      <div className="flex justify-between">
        <Button
          disabled={!selected}
          onClick={() => setCurrentStep(1)}
          className={`!bg-white border-black/20 border !text-burntBlack w-[160px] !h-11 !text-base font-bold ${!selected ? "opacity-50 cursor-not-allowed" : ""}`}
          variant="primary"
        >
          Cancel
        </Button>
        <Button
          onClick={() => setCurrentStep(currentStep + 1)}
          className={`mt-8 w-[160px] !h-11 !text-base font-bold ml-auto`}
          variant="primary"
        >
          Save & Continue
        </Button>
      </div>
    </>
  );
};

export default ChooseOpenLecture;
